import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconHandle = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M12.75 2.75C12.75 2.33579 13.0858 2 13.5 2C13.9142 2 14.25 2.33579 14.25 2.75V21.25C14.25 21.6642 13.9142 22 13.5 22C13.0858 22 12.75 21.6642 12.75 21.25V2.75Z M9.75 2.75C9.75 2.33579 10.0858 2 10.5 2C10.9142 2 11.25 2.33579 11.25 2.75V21.25C11.25 21.6642 10.9142 22 10.5 22C10.0858 22 9.75 21.6642 9.75 21.25V2.75Z" }),
});

export { IconHandle };
